module.exports = __webpack_public_path__ + "static/b3-b88e9828161d447eff4870723919518f.jpg";